import React from 'react';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

const SnackbarSection = ({ snackbar, handleCloseSnackbar }) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={snackbar.open}
      autoHideDuration={4000}
      onClose={handleCloseSnackbar}
      key={snackbar.message}
      style={{ zIndex: 9999 }}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
        style={{
          fontSize: '1rem',
          fontWeight: 500,
          minWidth: '300px',
        }}
      >
        {snackbar.message}
      </MuiAlert>
    </Snackbar>
  );
};

export default SnackbarSection;

